import { render, staticRenderFns } from "./Cytology.vue?vue&type=template&id=f589b844&scoped=true&"
import script from "./Cytology.vue?vue&type=script&lang=js&"
export * from "./Cytology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f589b844",
  null
  
)

export default component.exports